module.exports = __webpack_public_path__ + "static/media/icon-client-edit.8a2ff53b.svg";